import { Component, Input, Output, EventEmitter, inject, OnInit, signal, OnChanges, SimpleChanges, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { MatDatepicker, MatDatepickerToggle, MatDatepickerToggleIcon } from '@angular/material/datepicker';
import { MatFormField, MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatRadioButton, MatRadioGroup, MatRadioModule } from '@angular/material/radio';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { FormGroup, FormBuilder, ReactiveFormsModule, Validators, RequiredValidator, AbstractControl } from '@angular/forms';
import { MAT_DATE_FORMATS, MatNativeDateModule } from '@angular/material/core';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { CommonModule, formatDate } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { SelectOptions } from '../../../../../core/interfaces/select-options.interface';
import { HttpStatusCode } from 'axios';
import { NewRepApplicationService } from '../../new-rep-application-services/new-rep-application.service';
import { MatButtonModule } from '@angular/material/button';
import { ViewNewRepApplication } from '../../new-rep-application-interfaces/viewnew-rep-application.interface';
import { viewAttachements } from '../../new-rep-application-interfaces/attachements.interface';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmPopupComponent } from '../../confirm-popup/confirm-popup.component';
import { SnackbarService } from '../../../../../shared/services/snackbar/snackbar.service';
import { SessionStorageService } from '../../../../../core/services/session-storage/session-storage.service';
import { PersonalDetailService } from './personal-details-sercive/personal-detail-service';
import { Router } from '@angular/router';
import { PersonalDetailModel } from './personal-detail-model/personal-detail-model';
import { noWhitespace } from '../../../../../shared/validators/no-whitespace.validator';
import moment from 'moment';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@Component({
  selector: 'app-personal-details',
  providers: [provideMomentDateAdapter(MY_FORMATS)],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatRadioModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatIcon
  ],
  templateUrl: './personal-details.component.html',
  styleUrl: './personal-details.component.scss'
})
export class PersonalDetailsComponent implements OnInit {
  @Output() next = new EventEmitter<string[]>();
  @Input() formGroup!: FormGroup;
  @Input() personaldetails!: ViewNewRepApplication;
  @Input() viewattachments!: viewAttachements[];
  @Input() readonly = signal(false);
  @Output() preview = new EventEmitter<string[]>();
  @Output() save = new EventEmitter<string>();

  protected nationalities!: SelectOptions[];
  protected countries!: SelectOptions[];

  readonly message = 'This field is required.';
  data = history.state;


  private fb = inject(FormBuilder);
  private readonly matDialog = inject(MatDialog);
  private newRepApplicationService = inject(NewRepApplicationService);
  private sessionStorageService = inject(SessionStorageService);
  private snackBarService = inject(SnackbarService);
  private personalDetailService = inject(PersonalDetailService);
  private router = inject(Router);
  status = 'Not Started';
  nricrequired = signal(false);
  passportRequired = signal(false);
  firstset = signal(false);
  setSprinner = signal(false);


  role = '';
  isVisible = signal(false);

  ngOnInit() {

    this.formGroup.addControl('fullName', this.fb.control('', [noWhitespace]));
    this.formGroup.addControl('preferredName', this.fb.control(''));
    this.formGroup.addControl('nric', this.fb.control(''));
    this.formGroup.addControl('attachment_nric', this.fb.control([null]));
    this.formGroup.addControl('nricattachmentfileName', this.fb.control(''));
    this.formGroup.addControl('gender', this.fb.control(''));
    this.formGroup.addControl('dob', this.fb.control(''));

    this.formGroup.addControl('nationality', this.fb.control(''));
    this.formGroup.addControl('otherNationality', this.fb.control(''));
    this.formGroup.addControl('countryofbirth', this.fb.control(''));
    this.formGroup.addControl('passport', this.fb.control(''));
    this.formGroup.addControl('attachment_finorpassport', this.fb.control([null]));
    this.formGroup.addControl('finorpassportattachmentfileName', this.fb.control(''));
    this.formGroup.addControl('race', this.fb.control(''));
    this.formGroup.addControl('raceSpecify', this.fb.control(''));
    this.formGroup.addControl('maritalStatus', this.fb.control(''));

    this.handleRaceChanges();
    this.handleNationalityChanges();

    this.role = this.sessionStorageService.getCurrentUserRole();
    if ((this.role === 'DSU' || this.role === 'DSU Manager') && !this.personaldetails) {
      this.isVisible.set(true);
      this.getPersonalDetails();
    } else {
      this.personalDetailsfetchData();
    }
    this.handleFormStatus();

    this.getDropdownOptions();


  }

  personalDetailsfetchData(): void {
    this.formGroup.controls['fullName']?.setValue(this.personaldetails?.fullNameNric);
    this.formGroup.controls['preferredName']?.setValue(this.personaldetails?.preferredName);
    this.formGroup.controls['nric']?.setValue(this.personaldetails?.nricNo);

    this.viewattachments.forEach(item => {
      if (item?.onboardingDocumentType === 'Attachment(NRIC)') {
        this.formGroup.controls['nricattachmentfileName']?.setValue(item?.fileName);
      } else if (item?.onboardingDocumentType === 'Attachment(FIN or Passport)') {
        this.formGroup.controls['finorpassportattachmentfileName']?.setValue(item?.fileName);
      }
    })
    if (this.role === 'DSU' || this.role === 'DSU Manager') {
      const attachmentcategory = {
        'Attachment(NRIC)': 'nricattachmentfileName',
        'Attachment(FIN or Passport)': 'finorpassportattachmentfileName'
      }
      Object.entries(attachmentcategory).forEach(([category, controlName]) => {
        const latestDocument = this.viewattachments
          ?.filter(item => item?.onboardingDocumentType === category)
          ?.sort((a, b) => Number(b.id) - Number(a.id))[0];
        if (latestDocument) {
          this.formGroup.controls[controlName]?.setValue(
            latestDocument.fileName
          );
        }
      });
    }

    this.formGroup.controls['gender']?.setValue(this.personaldetails?.gender);
    if (this.personaldetails?.dateOfBirth !== '1900-01-01T00:00:00Z') {
      this.formGroup.controls['dob']?.setValue(this.personaldetails?.dateOfBirth);
    }
    
    if (this.personaldetails?.nationality != '') {
      if (this.personaldetails?.nationality == 'Singapore Citizen') {
        this.formGroup.controls['nationality']?.setValue(this.personaldetails?.nationality);
        this.formGroup.controls['otherNationality']?.setValue('Singaporean');
      } else if (this.personaldetails?.nationality.split(',')[0] == 'Singapore Permanent Resident') {
        const nationality = this.personaldetails?.nationality.split(',');
        this.formGroup.controls['nationality']?.setValue(nationality[0]);
        this.formGroup.controls['otherNationality']?.setValue(nationality[1]);
      } else {
        const nationality = this.personaldetails?.nationality.split(',');
        this.formGroup.controls['nationality']?.setValue(nationality[0]);
        this.formGroup.controls['otherNationality']?.setValue(nationality[1]);
      }
    }

    this.formGroup.controls['countryofbirth']?.setValue(this.personaldetails?.placeOfBirth);
    this.formGroup.controls['passport']?.setValue(this.personaldetails?.finPassportNo);
    if (this.personaldetails?.race === 'chinese' || this.personaldetails?.race === 'malay' || this.personaldetails?.race === 'indian') {
      this.formGroup.controls['race']?.setValue(this.personaldetails?.race);
    } else if (this.personaldetails?.race != '') {
      this.formGroup.controls['race']?.setValue('others');
      this.formGroup.controls['raceSpecify']?.setValue(this.personaldetails?.race);
    }

    this.formGroup.controls['maritalStatus']?.setValue(this.personaldetails?.maritalStatus);
    this.formGroup.updateValueAndValidity();
    if (this.formGroup.valid) {
      const nricAttachment = this.formGroup.get('nricattachmentfileName')?.value;
      const passportAttachment = this.formGroup.get('finorpassportattachmentfileName')?.value;

      const isOthers =
        ['others'].includes(
          this.formGroup.get('nationality')?.value
        );

      this.status = isOthers
        ? (passportAttachment ? 'Completed' : 'In Progress')
        : (nricAttachment ? 'Completed' : 'In Progress');

      this.next.emit([this.status, 'submitted']);
    } else if (this.formGroup.invalid) {
      this.status = 'In Progress';
      this.next.emit([this.status, 'submitted']);
    }
    // Everything below is silent. It runs after the status was emitted above, so
    // any announcement here would reach the status watcher as a user edit and
    // downgrade a completed section to "In Progress" the moment it loaded.
    if (this.readonly() == true) {
      this.formGroup?.disable();
      this.formGroup.controls['nric']?.disable();
      if (this.personaldetails?.nationality == 'Singapore Citizen') {
        this.formGroup.controls['otherNationality']?.setValue('Singaporean');
      } else {
        const nationality = this.personaldetails?.nationality.split(',');
        this.formGroup.controls['otherNationality']?.setValue(nationality[1]);
      }

    } else {
      this.formGroup?.enable();
      if (this.personaldetails?.nationality == 'Singapore Citizen') {
        this.formGroup.controls['otherNationality']?.disable();
        this.formGroup.controls['otherNationality']?.setValue('Singaporean');
        this.formGroup.controls['passport']?.disable();
      } else {
        this.formGroup.controls['otherNationality']?.enable();
        const nationality = this.personaldetails?.nationality.split(',');
        this.formGroup.controls['otherNationality']?.setValue(nationality[1]);
        if (nationality[0] == 'Singapore Permanent Resident') {
          this.formGroup.controls['passport']?.disable();
        } else {
          this.formGroup.controls['passport']?.enable();
        }
      }

    }
  }



  async getDropdownOptions() {

    const responseData = await this.newRepApplicationService
      .getDropdownOptions()
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });


    if (responseData.status === HttpStatusCode.Ok) {
      this.nationalities = responseData.data.responsedata.constants.nationality_list;
      this.countries = responseData.data.responsedata.constants.country_list;
    }
  }

  handleRaceChanges() {
    const race = this.formGroup.get('race');
    const raceSpecify = this.formGroup.get('raceSpecify');

    race?.valueChanges.subscribe(value => {
      if (value === 'others') {
        raceSpecify?.setValidators([Validators.required]);
      } else {
        raceSpecify?.clearValidators();
        raceSpecify?.reset();
      }
      raceSpecify?.updateValueAndValidity({ emitEvent: false });
    });
  }

  handleNationalityChanges() {
    const nationality = this.formGroup.get('nationality');

    const nric = this.formGroup.get('nric');
    const attachmentNric = this.formGroup.get('attachment_nric');
    const attachmentNricFilename = this.formGroup.get('nricattachmentfileName');
    const passport = this.formGroup.get('passport');
    const attachmentPassport = this.formGroup.get('attachment_finorpassport');
    const attachmentPassportFilename = this.formGroup.get('finorpassportattachmentfileName');
    const otherNationality = this.formGroup.get('otherNationality');

    nationality?.valueChanges.subscribe(value => {
      if (value === 'others') {
        nric?.clearValidators();
        attachmentNric?.clearValidators();

        nric?.reset();
        attachmentNric?.reset();
        attachmentNricFilename?.reset();
        nric?.disable();
        attachmentNricFilename?.disable();
        const fileInput = document.getElementById('nricattachmentfileName') as HTMLInputElement;
        if (fileInput) {
          fileInput.value = '';
        }

        passport?.setValidators([Validators.required, noWhitespace]);
        attachmentPassport?.setValidators([Validators.required]);
        otherNationality?.setValidators([Validators.required]);
        passport?.enable();
        attachmentPassport?.enable();
        attachmentPassportFilename?.enable();
        this.passportRequired.set(true);
        this.nricrequired.set(false);

        otherNationality?.reset();
        otherNationality?.enable();

      } else if (value === 'Singapore Permanent Resident') {
        nric?.setValidators([Validators.required, noWhitespace]);
        attachmentNric?.setValidators([Validators.required]);
        otherNationality?.setValidators([Validators.required]);
        nric?.enable();
        attachmentNricFilename?.enable();
        this.nricrequired.set(true);
        this.passportRequired.set(false);
        otherNationality?.reset();
        otherNationality?.enable();
        passport?.clearValidators();
        attachmentPassport?.clearValidators();
        passport?.reset();
        attachmentPassport?.reset();
        attachmentPassportFilename?.reset();
        passport?.disable();
        attachmentPassportFilename?.disable();
        const fileInput = document.getElementById('finorpassportattachmentfileName') as HTMLInputElement;
        if (fileInput) {
          fileInput.value = '';
        }

      } else if (value === 'Singapore Citizen') {
        nric?.setValidators([Validators.required, noWhitespace]);
        attachmentNric?.setValidators([Validators.required]);
        nric?.enable();
        attachmentNricFilename?.enable();
        otherNationality?.setValue('Singaporean');
        otherNationality?.disable();
        this.nricrequired.set(true);
        this.passportRequired.set(false);

        passport?.clearValidators();
        attachmentPassport?.clearValidators();
        passport?.reset();
        attachmentPassport?.reset();
        attachmentPassportFilename?.reset();
        passport?.disable();
        attachmentPassportFilename?.disable();
        const fileInput = document.getElementById('finorpassportattachmentfileName') as HTMLInputElement;
        if (fileInput) {
          fileInput.value = '';
        }
      }

      // Update all affected controls once
      [nric, attachmentNric, passport, attachmentPassport].forEach(ctrl =>
        ctrl?.updateValueAndValidity({ emitEvent: false })
      );
    });
  }
  handleFormStatus() {
    // Nothing in a read-only section can be a user edit - the form is disabled.
    // Every emission here is programmatic: the saved data being loaded, and
    // disable() itself, which empties formGroup.value so it can never match the
    // baseline below. Each one overwrote the status the section had just derived
    // from that data, leaving a completed application reading "In Progress".
    if (this.readonly()) return;

    const initialValue = this.formGroup.getRawValue();

    this.formGroup.valueChanges.subscribe(currentValue => {
      const hasChanged =
        JSON.stringify(initialValue) !== JSON.stringify(currentValue);

      if (hasChanged) {
        this.status = 'In Progress';
        this.next.emit([this.status, 'change']);
      }
    });
  }

  onAttachmentFileChange(event: any, controlName: string, fileVar: string): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    const control = this.formGroup.get(controlName);

    // ✅ Valid file → update form properly
    this.formGroup.patchValue({
      [fileVar]: file,
      [controlName]: file?.name
    });

    if (!control) return;

    // Reset first
    control.markAsTouched();
    control.setErrors(null);

    if (!file) {
      control.setValue(null);
      return;
    }

    const allowedTypes = new Set([
      'application/pdf',
      'image/jpeg',
      'image/png'
    ]);

    const maxSize = 5 * 1024 * 1024; // 5MB

    // Validate type
    if (!allowedTypes.has(file.type)) {
      control.setErrors({ invalidType: true });
      return;
    }

    // Validate size
    if (file.size > maxSize) {
      control.setErrors({ maxSize: true });
      return;
    }

    control.updateValueAndValidity();
    this.uploaddocument(fileVar, controlName);
  }

  async uploaddocument(fileVar: string, controlName: string) {
    let categoryName!: string;

    if (fileVar == 'attachment_nric') {
      categoryName = 'Attachment(NRIC)';
    } else {
      categoryName = 'Attachment(FIN or Passport)';
    }

    const formData = new FormData();

    formData.append('file', this.formGroup.get(fileVar)?.value);
    formData.append('Description', categoryName);
    formData.append('filename', this.formGroup.get(fileVar)?.value?.name);
    formData.append('ResponseValue', '');
    if (this.role === 'DSU' || this.role === 'DSU Manager') {
      formData.append('UserId', String(this.data.applicant.onboardingid));
    }


    const responseData = await this.newRepApplicationService
      .uploadDocuments(formData)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    if (responseData.status === HttpStatusCode.Ok) {
      this.formGroup.patchValue({
        [controlName]: responseData.data.responsedata
      });

      if (this.role === 'DSU' || this.role === 'DSU Manager') {
        this.viewDsuDocuments();
      } else {
        this.viewDocumants();
      }

      this.snackBarService.openSuccessSnackBar("document uploaded successfully!");
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
    }
  }

  removeFile(controlName: string, fileVar: string, categoryname: string) {
    const dialogRef = this.matDialog.open(ConfirmPopupComponent, {
      width: '500px',
      disableClose: true,
      data: {
        message: 'Do you want to remove the attachement?',
        hidecancel: false,
      }
    });
    if (this.role === 'DSU' || this.role === 'DSU Manager') {
      this.viewDsuDocuments();
    } else {
      this.viewDocumants();
    }
    dialogRef.afterClosed().subscribe(async result => {
      if (result.data === true) {
        if (this.viewattachments) {
          let onboardingId;
          let id;
          let docTypeId;

          //new change
          if (this.role === 'DSU' || this.role === 'DSU Manager') {
            // this.viewattachments.forEach(item => {
            //   if (item?.onboardingDocumentType === categoryname && ['DSU', 'DSU Manager'].includes(item.updatedByRole)) {
            //     onboardingId = this.data.applicant.onboardingid;
            //     docTypeId = item.docTypeId;
            //     id = item.id;
            //   }
            // })
            const latestDocument = this.viewattachments
              ?.filter(item => item?.onboardingDocumentType === categoryname && ['DSU', 'DSU Manager'].includes(item.updatedByRole))
              ?.sort((a, b) => Number(b.id) - Number(a.id))[0];
            if (latestDocument) {
              onboardingId = this.data.applicant.onboardingid;
              docTypeId = latestDocument.docTypeId;
              id = latestDocument.id;
            }
          } else {
            this.viewattachments.forEach(item => {
              if (item?.onboardingDocumentType === categoryname) {
                onboardingId = item.onboardingId;
                docTypeId = item.docTypeId;
                id = item.id;
              }
            })
          }
          //new change 
          const data = {
            onboardingId: onboardingId,
            docTypeId: docTypeId,
            id: id
          }
          //new change 
          if (id) {
            const responseData = await this.newRepApplicationService
              .deletedocument(data)
              .then((response) => {
                return JSON.parse(response);
              })
              .catch((error) => {
                // console.error(error);
                return error;
              });
          }
        }
        this.formGroup.get(controlName)?.reset();
        this.formGroup.get(fileVar)?.reset();
        const fileInput = document.getElementById(controlName) as HTMLInputElement;
        if (fileInput) {
          fileInput.value = '';
        }
        this.formGroup.controls[controlName].markAsTouched();
        this.formGroup.controls[controlName].updateValueAndValidity();
      } else {
        // console.log('User cancelled');
      }
    });

  }

  async viewDocumants() {
    const responseData = await this.newRepApplicationService
      .viewApplicationDetails(this.personaldetails?.id)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });

    this.viewattachments = responseData.data.responsedata.attachments;
  }

  async viewDsuDocuments() {
    let repCode = this.data.applicant.repcode;
    const responseData = await this.personalDetailService
      .getPersonalDetails(repCode)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    this.setSprinner.set(false);
    if (responseData.status === HttpStatusCode.Ok) {


      this.viewattachments = responseData.data.responsedata.documents;


    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }

  saveAndContinue() {

    // Validation or API save logic here

    // Save API call or form validation here
    if (this.formGroup.valid) {
      this.status = 'Completed';
    }
    this.formGroup.markAllAsTouched();

    this.next.emit([this.status, 'submit']);
  }

  previewAttachment(controlName: string, categoryName: string) {
    if (this.viewattachments) {
      let id;
      this.viewattachments.forEach(item => {
        if (item?.onboardingDocumentType === categoryName) {
          id = item.id;
        }
      });
      let filename = this.formGroup.get(controlName)?.value;
      this.preview.emit([id, filename]);
    }
  }

  async saveSection() {
    this.setSprinner.set(true);
    let savePersonalDetail = new PersonalDetailModel();
    savePersonalDetail.setPiasrepCode(this.data.applicant.repcode);
    savePersonalDetail.setFullNameNric(this.formGroup.get('fullName')?.value?.trim());
    savePersonalDetail.setPreferredName(this.formGroup.get('preferredName')?.value?.trim());
    savePersonalDetail.setNricNo(this.formGroup.get('nric')?.value?.trim());
    // savePersonalDetail.setDateOfBirth(this.formGroup.get('dob')?.value);
    const dobValue = this.formGroup.get('dob')?.value;
    if (dobValue) {
      const formatted = formatDate(dobValue, 'yyyy-MM-dd', 'en-US');
      savePersonalDetail.setDateOfBirth(formatted + 'T00:00:00Z');
    } else {
      savePersonalDetail.setDateOfBirth(dobValue);
    }
    savePersonalDetail.setGender(this.formGroup.get('gender')?.value);
    // savePersonalDetail.setNationality(this.formGroup.get('nationality')?.value);
    if (this.formGroup.get('nationality')?.value === 'others') {
      savePersonalDetail.setNationality([this.formGroup.get('nationality')?.value, this.formGroup.get('otherNationality')?.value?.trim()].toString());
    } else if (this.formGroup.get('nationality')?.value === 'Singapore Permanent Resident') {
      savePersonalDetail.setNationality([this.formGroup.get('nationality')?.value, this.formGroup.get('otherNationality')?.value?.trim()].toString());
    } else {
      savePersonalDetail.setNationality(this.formGroup.get('nationality')?.value);
    }
    savePersonalDetail.setPlaceOfBirth(this.formGroup.get('countryofbirth')?.value);
    savePersonalDetail.setFinPassportNo(this.formGroup.get('passport')?.value?.trim());
    if (this.formGroup.get('race')?.value === 'others') {
      savePersonalDetail.setRace(this.formGroup.get('raceSpecify')?.value?.trim());
    } else {
      savePersonalDetail.setRace(this.formGroup.get('race')?.value);
    }
    savePersonalDetail.setMaritalStatus(this.formGroup.get('maritalStatus')?.value);



    const responseData = await this.personalDetailService
      .savepersonalDetails(savePersonalDetail)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    this.setSprinner.set(false);
    if (responseData.status === HttpStatusCode.Ok) {
      // this.viewDsuAssessment();
      this.save.emit('saved');
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }

  }
  cancelSection() {
    this.save.emit('cancelled');
  }


  // GET PERSONAL DETAILS
  async getPersonalDetails() {
    this.setSprinner.set(true);
    let repCode = this.data.applicant.repcode;

    const responseData = await this.personalDetailService
      .getPersonalDetails(repCode)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    this.setSprinner.set(false);
    if (responseData.status === HttpStatusCode.Ok) {

      this.personaldetails = responseData.data.responsedata.personal_particular;
      this.viewattachments = responseData.data.responsedata.documents;
      this.personalDetailsfetchData();

    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }

  }



}
